




export default function Pay(){


    return (<>
   
    </>)
}